import styled, { css } from 'styled-components';

export const WrapperCheckBox = styled.div`
  height: 100%;
`;
export const CheckBox = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  border: 1.5px solid rgba(1, 3, 54, 0.15);

  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const CheckList = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.x6};
`;

export const CheckInputList = styled.div`
  padding: ${({ theme }) => theme.spacing.x3};
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x2};
`;
export const CheckInput = styled.input`
  background: rgba(1, 3, 54, 0.02);
  border: 1px solid rgba(1, 3, 54, 0.25);
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.rounded.x1};
`;

export const SendMessageButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.rounded.x50};
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x1} 7px ${theme.spacing.x2}`} !important;
`;
export const AttachButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.rounded.x50};
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x1} 7px 5px `} !important;
  margin-inline-end: 1rem;
`;

export const WrapperMessage = styled.div<{ $me: boolean }>`
  + * {
    margin-top: ${({ theme }) => theme.spacing.x4};
  }
`;

export const MessageRow = styled.div`
  position: relative;
`;

export const messageCard = styled.div<{ $me: boolean }>`
  max-width: 50%;
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  border-radius: ${({ theme }) => theme.rounded.x3};
  color: ${({ theme }) => theme.palette.white_90};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x6}`};
  ${({ $me }) =>
    $me
      ? css`
          border-bottom-right-radius: 0 !important;
          background-color: ${({ theme }) => theme.palette.secondary};
        `
      : css`
          border-bottom-left-radius: 0 !important;
          //TODO: background issue
          background-color: ${({ theme }) => theme.palette.lightText};
        `}
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    max-width: 80%;
  }
`;

export const MessageCardSvgIcon = styled.div`
  position: absolute;
  bottom: 1px;
  height: ${({ theme }) => theme.spacing.x4};
  right: -7px;
`;

export const messageText = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
  line-height: 150%;
`;

export const RowAttach = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  gap: 3px;
`;

export const LinkFile = styled.a`
  text-decoration: underline;
  color: #fff;
`;

export const messageTime = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
  line-height: 150%;
  margin-top: ${({ theme }) => theme.spacing.x3};
`;

export const FileWrapper = styled.div`
  width: 30%;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 40%;
  }
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 50%;
  }
`;
